import { usePseudoClasses } from '@helsenorge/designsystem-react/hooks/usePseudoClasses';

import styles from './styles.module.scss';

interface FeedbackIconButtonProps {
  icons: {
    normal: string;
    hover: string;
    active: string;
  };
  ariaLabel: string;
  isSelected: boolean;
  onClick: () => void;
}

const FeedbackIconButton: React.FC<FeedbackIconButtonProps> = props => {
  const { refObject, isHovered, isActive } = usePseudoClasses<HTMLButtonElement>();
  let iconSrc: string;

  if (props.isSelected || isActive) {
    iconSrc = props.icons.active;
  } else if (isHovered) {
    iconSrc = props.icons.hover;
  } else {
    iconSrc = props.icons.normal;
  }

  return (
    <button
      type="button"
      ref={refObject}
      className={styles['summary__survey-button']}
      aria-label={props.ariaLabel}
      aria-pressed={props.isSelected}
      onClick={props.onClick}
    >
      <img src={iconSrc} alt="" aria-hidden="true" />
    </button>
  );
};

export default FeedbackIconButton;
